import React from "react";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import PageWrapper from "./PageWrapper";
import Home from '@mui/icons-material/Home';

const Heading = () => (
  <>
    <span style={{ display: "block", fontSize: "9rem" }}>404</span>
    <p style={{ display: "block", fontSize: "4rem" }}>Page not found!</p>
  </>
);

const NotFoundPage = () => {
  return (
    <PageWrapper heading={<Heading />}>
      <Heading />
      <p style={{ paddingTop: "3rem", lineHeight: "2", fontSize: "1.5rem", marginTop: 10 }}>
        Oops! We can’t find the page you are looking for. Try starting from the{" "}
        <Link to="/">homepage</Link> or visit our{" "}
        <a href="https://www.fastmap.ai/blog"
           target="_blank"
           rel="noopener noreferrer"
           aria-label="Opens link to blog in new tab">
          blog
        </a>{" "}
        to help point you in the right direction.
      </p>
      <Button variant="contained" size="xlarge" startIcon={<Home />} component={Link} to="/" sx={{ fontSize: '1.5rem', padding: '1rem 2.5rem', minWidth: '150px', minHeight: '50px' }}>
        HomePage
      </Button>
    </PageWrapper>
  );
};

export default NotFoundPage;